@if (currentEnvironment === 'development' || currentEnvironment === 'staging') {
  <div
    class="flex h-8 items-center justify-center border-b border-black/5 bg-yellow-100 bg-[length:0.8rem_0.8rem] px-3 text-center text-sm font-semibold text-yellow-800 [background-image:linear-gradient(45deg,rgba(0,0,0,0.03)_25%,transparent_25%,transparent_50%,rgba(0,0,0,0.03)_50%,rgba(0,0,0,0.03)_75%,transparent_75%,transparent)]"
  >
    {{ currentEnvironment | uppercase }}
  </div>
}

<router-outlet></router-outlet>
<hlm-toaster [richColors]="true" />
